import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import './EquipmentCheckSheet.scss';

import { getSessionOptions } from 'util/options';
import { getCurrentMeet } from 'selectors';

class EquipmentCheckSheet extends Component {

  render() {
    const { meet } = this.props;

    const lifters = _.sortBy(meet.lifters, ['name']);

    return (
      <div className="check-in-sheet">
        {
          _.map(getSessionOptions(), (session) => {
            const sessionLifters = _.filter(lifters, {session: session.value});
            const sessionCount = _.size(sessionLifters);
            if(!sessionCount) {
              return null;
            }

            return (
              <div key={session.value} className="session-pages">
                <div className="meet-name">{meet.date} - {meet.name} - Session {session.value} - EQUIPMENT CHECK</div>
                <table>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Member #</th>
                      <th>Flight</th>
                      <th>Lot #</th>
                      <th style={{width: '22%'}}>Remarks</th>
                      <th style={{width: '25%'}}>Signature</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      _.map(sessionLifters, (lifter) => {
                        return (
                          <tr key={lifter._id}>
                            <td>{lifter.name}</td>
                            <td>{lifter.restricted.memberNumber}</td>
                            <td>{lifter.flight}</td>
                            <td>{lifter.lot}</td>
                            <td></td>
                            <td></td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(EquipmentCheckSheet);
